// Local events only. An analytics adapter can subscribe after consent.
// Never include form contents, contact details, full URLs or query strings.
export function emitConversion(event, serviceSlugs = []) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent("nexxsite:conversion", {
    detail: { event, services: serviceSlugs },
  }));
}
